(function (root, factory) {
  const api = factory();
  if (typeof module !== 'undefined') module.exports = api;
  root.MenasaGalleryMap = api;
}(typeof globalThis === 'undefined' ? this : globalThis, function () {
  const catalog = {
    'menasa-cash-zip': {
      'navy blue': ['Q-p1_1.png', 'Q_zip_1_1.jpg', 'Q3_1.png', 'Q-1_0af2eb36-48c9-4bce-aefc-7bc7d4a02516.jpg', 'Q-22.jpg', 'Q-33.jpg'],
      black: []
    },
    'menasa-logo-embroidered-hoodie': {
      navy: ['m11.png', 'm2_2.png', 'M-3_9a819a6d-b7ce-443d-9712-b8685d1fbb23.jpg', 'M-4_c8b5fe2c-9a00-41ef-bad1-78d634114463.jpg'],
      brown: ['m33.png', 'm44.png', 'M-1_a9eb0035-886b-4217-b9cc-e155338cb125.jpg', 'M-2_b6803b5b-bcf0-44c4-af43-c906bb1530c7.jpg']
    },
    'menasa-orient-hat': {
      black: ['hat_1.png', 'H2_1.png', 'hat_3.png'],
      'navy blue': ['H4_1.png', 'H5_1.png', 'H6_1.png', 'hat11.png', 'HAT_-_2_be795fc5-1f51-4dc1-9526-3ae463ec8b73.jpg', 'HAT_-_3_MAKE_BLACK_f57f2a8d-92b3-460d-9719-408b527c81d6.jpg', 'HAT_-_4_MAKE_BLACK_6cec72a3-8960-4e31-8778-0fc909e7b50d.jpg']
    }
  };

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function filename(value) {
    const clean = String(value || '').split('?')[0].split('#')[0];
    try {
      return decodeURIComponent(clean.slice(clean.lastIndexOf('/') + 1));
    } catch (_error) {
      return clean.slice(clean.lastIndexOf('/') + 1);
    }
  }

  function parseOverrides(value) {
    if (!value || !String(value).trim()) return {};
    try {
      const parsed = JSON.parse(value);
      if (!parsed || Array.isArray(parsed) || typeof parsed !== 'object') return {};
      return Object.keys(parsed).reduce(function (result, colour) {
        if (Array.isArray(parsed[colour]) && parsed[colour].every(item => typeof item === 'string')) {
          result[normalize(colour)] = parsed[colour].map(filename).filter(Boolean);
        }
        return result;
      }, {});
    } catch (_error) {
      return {};
    }
  }

  function nativeMap(variants) {
    return (variants || []).reduce(function (result, variant) {
      const colour = normalize(variant.colour);
      const imageId = String(variant.imageId || '');
      if (!colour || !imageId) return result;
      if (!result[colour]) result[colour] = [];
      if (!result[colour].includes(imageId)) result[colour].push(imageId);
      return result;
    }, {});
  }

  function resolve(handle, colour, overrideValue, variants) {
    const key = normalize(colour);
    if (!key) return { known: false, filenames: [], mediaIds: [], source: 'none' };
    const overrides = typeof overrideValue === 'string' ? parseOverrides(overrideValue) : (overrideValue || {});
    if (Object.prototype.hasOwnProperty.call(overrides, key)) {
      return { known: true, filenames: overrides[key], mediaIds: [], source: 'merchant' };
    }
    const native = nativeMap(variants);
    const productMap = catalog[normalize(handle)] || {};
    if (Object.prototype.hasOwnProperty.call(productMap, key)) {
      const nativeIds = native[key] || [];
      return {
        known: true,
        filenames: productMap[key],
        mediaIds: nativeIds,
        source: nativeIds.length ? 'native-and-verified-catalog' : 'verified-catalog'
      };
    }
    if (Object.prototype.hasOwnProperty.call(native, key) && native[key].length) {
      return { known: true, filenames: [], mediaIds: native[key], source: 'native-variant' };
    }
    return { known: false, filenames: [], mediaIds: [], source: 'none' };
  }

  return { catalog: catalog, filename: filename, nativeMap: nativeMap, normalize: normalize, parseOverrides: parseOverrides, resolve: resolve };
}));
